import { FETCH_LEAD_FILTER_LOGS } from '../actions/index';

const INITIAL_STATE = { all: {} };
const ROOT_URL = process.env.API_ROOT_URL.replace('/v1','');

export default function(state = INITIAL_STATE, action) {
  if (action.payload && action.payload.data == "missing 'X-Site-UUID' header") {
    window.location = `${ROOT_URL}/auth/realgeeks`;
  }
  switch(action.type) {
  case FETCH_LEAD_FILTER_LOGS:
    return { ...state, all: action.payload.data };
  default:
    return state;
  }
}

